// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2mg5K","header":"MessagesList_header__1V0ju","chat":"MessagesList_chat__19ckV"};